module.exports = __webpack_public_path__ + "static/media/fonts-7.d44b89a2.svg";